export default {
  codeColor: Styles.color.white,
};
